<template>
  <el-main
    v-loading="submitDisabled"
    :element-loading-text="$t(&quot;loginVue.spinner&quot;)"
  >
    <el-row type="flex">
      <el-col :xs="1" :sm="2" :lg="8">
        <div class="">&nbsp;</div>
      </el-col>

      <el-col :xs="23" :lg="12">
        <div class="">
          <el-container>
            <el-main>
              &nbsp;
              <el-form ref="form" label-position="top" :model="form" :rules="rules" label-width="120px" hide-required-asterisk @submit.prevent="onSubmit">
                <el-row type="flex">
                  <el-col :xs="24" :lg="24">
                    <div class="login-title contentResize ">{{ $t("loginVue.title") }}</div>
                  </el-col>
                </el-row>

                <el-row type="flex">
                  <el-col :xs="24" :lg="24">
                    <div>&nbsp;</div>
                  </el-col>
                </el-row>

                <el-form-item :label="$t(&quot;loginVue.username&quot;)" prop="username">
                  <el-row type="flex">
                    <el-col :xs="24" :lg="16">
                      <el-input v-model="form.username" :placeholder="$t(&quot;loginVue.username-ph&quot;)" />
                    </el-col>
                  </el-row>
                </el-form-item>

                <el-form-item :label="$t(&quot;loginVue.password&quot;)" prop="password">
                  <el-row>
                    <el-col :xs="24" :lg="16">
                      <el-input v-model="form.password" type="password" :placeholder="$t(&quot;loginVue.password-ph&quot;)" @keyup.enter.native="submitForm('form')" />
                    </el-col>
                  </el-row>
                </el-form-item>

              </el-form>

              <el-row>
                <el-col><div class="login-title">&nbsp;</div></el-col>
              </el-row>

              <el-row>
                <el-col :xs="24" :lg="16">
                  <el-button :disabled="submitDisabled" @click="submitForm('form')">{{ $t("loginVue.loginButton") }}</el-button>
                </el-col>
              </el-row>

              <el-row>
                <el-col :xs="24" :lg="16">
                  <div id="disclaimer">{{ $t("loginVue.disclaimer") }}</div>
                </el-col>
              </el-row>

            </el-main>
          </el-container>
        </div>
      </el-col>
    </el-row>
  </el-main>
</template>

<script>
export default {
  data() {
    return {
      submitDisabled: false,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: this.$t('loginVue.rules.username'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('loginVue.rules.password'), trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.$store.watch(
      (state, getters) => getters['authStore/getRequestComplete'],
      (newValue, oldValue) => {
        // console.log('newValue', newValue)
        if (newValue) {
          this.submitDisabled = false
          if (!this.$store.getters['authStore/isAuthenticated']) {
            this.$message.error({
              message: this.$t('loginVue.validate.usrPW'),
              center: true
            })
          }
        }
      },
    )
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitDisabled = true
          const formData = {
            username: this.form.username,
            password: this.form.password
          }

          this.$store.dispatch('authStore/login', { username: formData.username, password: formData.password })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
  .el-form-item .el-button:hover,
  .el-form-item .el-button:active {
    background-color: #00AEEF;
    color: white;
  }

  .el-form-item .el-button[disabled],
  .el-form-item .el-button[disabled]:hover,
  .el-form-item .el-button[disabled]:active {
    border: 1px solid #ccc;
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
  }

.login-title {
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

#disclaimer{
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #707070;
}

.sideDiv1{
  background-color: palegreen;
}

.sideDiv2{
  background-color: plum;
}

.sideDiv3{
  background-color: burlywood;
}

@media screen and (min-width: 601px) {
  div.contentResize {
    font-size: 40px;
  }
}

@media screen and (max-width: 600px) {
  div.contentResize {
    font-size: 22px;
  }
}

.el-button  {
  border-radius: 4px;
  background-color: #f5c923;
  width: 100%;
  font-size: 18px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}
.el-button:hover,
.el-button:active {
  background-color: #00AEEF;
  color: white;
}
</style>
